import styled, { css } from 'styled-components';
import { MAccordionHeaderAlignment } from './MAccordionHeader.types';

const stylesByAlignment = ({ alignment }: { alignment: MAccordionHeaderAlignment }) => {
  return alignment === MAccordionHeaderAlignment.Centered
    ? css`
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-end;
        & .m-accordion-header-title {
          display: flex;
          align-items: flex-start;
          align-self: stretch;
          justify-content: center;
        }
      `
    : css`
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-end;
        justify-content: space-between;
        & .m-accordion-header-title {
          flex: 1 0 0;
        }
      `;
};

export const Wrapper = styled.div<{ alignment: MAccordionHeaderAlignment }>`
  display: flex;
  width: 100%;
  ${stylesByAlignment}
  & .m-accordion-header-toggle {
    display: flex;
    align-items: center;
  }
`;
